export const REQUEST_MESSAGES = {
  // Address validation
  SOURCE_DESTINATION_SAME: "Source and Destination cannot be the same.",
  RETURN_SOURCE_DESTINATION_SAME:
    "Return Source and Return Destination cannot be the same.",
  ADDRESS_ENTER_FIRST: "Please enter an address first.",
  ADDRESS_NOT_FOUND: "Address not found.",

  // Declaration
  DECLARATION_BEFORE_SUBMIT:
    "Please check mark the declaration before submission.",
  ID_PROOF_DECLARATION_REQUIRED:
    "Please check mark the ID proof declaration before saving information.",

  // Individual validation
  ADD_INDIVIDUAL_FIRST: "Add at least one individual before saving information",
  COMPLETE_INDIVIDUAL_DETAILS:
    "Complete all individual details before saving information",
  SELECT_SAVED_INDIVIDUAL: "Select at least one saved individual to add",
  ADD_INDIVIDUAL_REQUIRED: "Add at least one individual",
  DIGITS_ONLY: "Enter digits only",
  ID_PROOF_REQUIRED: "ID Proof is required",

  // Upload validation
  TICKET_BILL_REQUIRED: "Ticket bill is required",
  ACCOMMODATION_BILL_REQUIRED: "Accommodation bill is required",
  PAYMENT_PROOF_REQUIRED: "Payment proof is required",

  // Save
  SAVE_INDIVIDUAL_SUCCESS: "Individual information saved successfully",
  SAVE_INDIVIDUAL_FAILED: "Failed to save individual information",

  // Fetch
  FETCH_REQUEST_FAILED: "Failed to fetch request data",
  FETCH_SAVED_INDIVIDUALS_FAILED: "Failed to fetch saved information",
  FETCH_SAVED_ADDRESSES_FAILED: "Failed to fetch saved addresses",

  // Validation
  VALIDATION_FAILED: "Validation failed",
  MANDATORY_FIELDS_REQUIRED: "Please fill all mandatory fields",
};